import React, { createContext, useContext, useCallback } from 'react';
import { useProgress } from '@hooks';
import { useAuth } from './AuthContext';

/**
 * Progress Context for user progress tracking
 */
const ProgressContext = createContext(null);

export function ProgressProvider({ courseId, children }) {
  const { user } = useAuth();
  const { progress, loading, error, refreshProgress } = useProgress(user?.id, courseId);

  const value = {
    progress,
    loading,
    error,
    refreshProgress,
  };

  return <ProgressContext.Provider value={value}>{children}</ProgressContext.Provider>;
}

export function useProgressContext() {
  const context = useContext(ProgressContext);
  if (!context) {
    throw new Error('useProgressContext must be used within ProgressProvider');
  }
  return context;
}
